import ignite from '../../../services';

const ConversationTestActions = {
  CONV_TEST_REQUEST_STARTED: 'CONV_TEST_REQUEST_STARTED',
  CONV_TEST_REQUEST_FAILED: 'CONV_TEST_REQUEST_FAILED',
  CONV_TEST__REQUEST_SUCCESSFUL: 'CONV_TEST__REQUEST_SUCCESSFUL',
};

const loadTestData = () => {
  return async (dispatch) => {
    try {
      dispatch(
        triggerAction(ConversationTestActions.CONV_TEST_REQUEST_STARTED)
      );
      const testPageData = await ignite.conversationTestService.loadGuideConversationForTesting();
      dispatch(dataLoaded(testPageData));
    } catch (ex) {
      dispatch(
        requestFailed(ConversationTestActions.CONV_TEST_REQUEST_FAILED, ex)
      );
    }
  };
};

const triggerAction = (type) => {
  return {
    type,
  };
};

const requestFailed = (type, error) => {
  return {
    type,
    error,
  };
};

const dataLoaded = (data) => {
  return {
    type: ConversationTestActions.CONV_TEST__REQUEST_SUCCESSFUL,
    data,
  };
};

export { ConversationTestActions, loadTestData };
